import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedDate, FormattedMessage, injectIntl} from "react-intl";
import {Button} from "reactstrap";
import {handleApiResponse} from "../../../crud-actions";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class OrientationDay extends BaseComponent {

    constructor(params) {
        super(params);
        this.state = {
            downloading: false
        }
    }

    markAsDone = (notify = true) => {
        const assignmentId = this.props.assignment.id;
        let promise = this.props.assignmentAction('api/v1', assignmentId, { execute: 'mark_as_done' });
        return handleApiResponse('ASSIGNMENT','ACTION', promise,
            (response) => {
                if (notify) {
                    this.props.push('/dashboard/');
                    this.props.setNotification('success', this.props.intl.formatMessage({id: "app.content_units.mark_as_done.success"}));
                }
            },
            (response) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            },
            (response) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
            });
    };

    render() {
        const { readOnly, assignment } = this.props;
        const orientationDay = assignment.employee_data.orientation_day;
        const contentUnit = assignment.content_unit;
        const state = assignment.state;

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                    <hr/>
                    { !orientationDay &&
                    <p>
                        <FormattedMessage id='app.orientation_days.not_yet_set'/>
                    </p>
                    }
                    { orientationDay &&
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.address'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.address }</p>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.room'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.room }</p>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.come_to'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.come_to }</p>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.contact_phone'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.contact_phone }</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.date'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p><FormattedDate value={orientationDay.datetime}/></p>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.duration_times'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.duration_times }</p>
                            </div>
                            {
                                orientationDay.signing_times && orientationDay.signing_times.length > 0 &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.orientation_days.attribute.signing_times'>{(txt) => (
                                        <label>{txt}</label>)}</FormattedMessage>
                                    <p>{orientationDay.signing_times}</p>
                                </div>
                            }
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.seminar_times'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.seminar_times }</p>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.orientation_days.attribute.bozp_times'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <p>{ orientationDay.bozp_times }</p>
                            </div>
                            {
                                orientationDay.trainers_meetup && orientationDay.trainers_meetup.length > 0 &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.orientation_days.attribute.trainers_meetup'>{(txt) => (
                                        <label>{txt}</label>)}</FormattedMessage>
                                    <p>{orientationDay.trainers_meetup}</p>
                                </div>
                            }
                        </div>
                    </div>
                    }
                    {
                        !readOnly && orientationDay && state !== 'complete' &&
                        <div>
                            <hr/>
                            <Button onClick={this.markAsDone}><FormattedMessage id='app.actions.mark_as_done'/></Button>
                        </div>
                    }
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        constants: state.constants
    };
}

function matchDispatchToProps(dispatch){ return bindActionCreators({}, dispatch); }

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(OrientationDay));
